<template>
  <div>
    <booking-list />
  </div>
</template>

<script>
import BookingList from './BookingList.vue'

export default {
  name: 'BookingsIndex',
  components: {
    BookingList
  }
}
</script>
